import { useEffect } from "react";
import { useLocation } from "react-router";
import { Loader2 } from "lucide-react";
import { PUBLIC_WEB_URL } from "../../utils/publicQr";

/**
 * QR landing lives on the visitor app. If a printed code accidentally points
 * at admin host, bounce to PUBLIC_WEB_URL with the same /go path.
 */
export function AdminQrGoRedirect() {
  const location = useLocation();

  useEffect(() => {
    const target = `${PUBLIC_WEB_URL}${location.pathname}${location.search}${location.hash}`;
    window.location.replace(target);
  }, [location.pathname, location.search, location.hash]);

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center gap-3 text-gray-500">
      <Loader2 className="animate-spin" size={24} />
      <p className="text-[14px]">Открываем страницу скана…</p>
    </div>
  );
}
